import React from "react";
import { useTranslation } from "react-i18next";
import ReactSwitch from "react-switch";
import { useSnapshot } from "valtio";

import "../index.css";

// Only the two fields this component reads. Any store exposing them works
// (ApplicationSetting general store, PrinterSetting general store, ...).
type InformationModeStore = {
    printerInformationMode: boolean;
    printerBold: boolean;
};

type InformationModeType = {
    rowData: any;
    // Valtio proxy the switches read/write. Passed in so the component is
    // bound to the caller's store instead of a hard-coded singleton.
    store: InformationModeStore;
    setInformationMode: (value: boolean) => void;
    setBold: (value: boolean) => void;
};

export default function InformationMode({
    store,
    setInformationMode,
    setBold,
}: InformationModeType) {
    const { t } = useTranslation();
    const { printerBold, printerInformationMode } = useSnapshot(store);

    React.useEffect(() => {
        if (!printerInformationMode) setBold(false);
    }, [printerInformationMode, setBold]);

    return (
        <React.Fragment>
            <div className="d-flex  align-items-center justify-content-between px-1 pt-2 pb-1">
                <b>{t("Information mode")}</b>
            </div>
            <div className="d-flex  align-items-center justify-content-between p-1">
                <div>{t("Print receipt information mode")}</div>
                <div className=" float-right mr-4">
                    <ReactSwitch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={printerInformationMode}
                        onChange={(e: any) => {
                            setInformationMode(!printerInformationMode);
                        }}
                        className="afa_icn_printInformationModeTicket"
                        data-testid="app-setting-information-mode-toggle"
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={55}
                        height={20}
                    />
                </div>
            </div>
            <div className="d-flex  align-items-center justify-content-between p-1">
                <div>{t("Print information mode in bold")}</div>
                <div
                    className="float-right mr-4"
                    style={{ opacity: !printerInformationMode ? "0.8" : "1" }}
                >
                    <ReactSwitch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={printerInformationMode ? printerBold : false}
                        onChange={(e: any) => {
                            setBold(!printerBold);
                        }}
                        onColor="#c2eddd"
                        className="afa_icn_printInformationModeBold"
                        data-testid="app-setting-information-mode-bold-toggle"
                        onHandleColor="#34C38F"
                        width={55}
                        height={20}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}
